import React from 'react';
import PromotionServicePage from './PromotionServicePage';

const BoomplayPromotionPage = () => {
  return (
    <PromotionServicePage
      platform="boomplay"
      platformName="Boomplay"
      iconColor="bg-gradient-to-br from-orange-500 to-yellow-500"
      description="Développez votre audience sur Boomplay, la plateforme de streaming N°1 en Afrique."
      metaTitle="Promotion Boomplay - 35$ | AGRP BOX"
      metaDescription="Augmentez vos streams sur Boomplay, la plateforme africaine de référence, avec notre service de promotion AGRP BOX."
      url="/promouvoir-boomplay"
    />
  );
};

export default BoomplayPromotionPage;
